module.exports = __webpack_public_path__ + "static/media/pic-history3.e7df3746.webp";